module.exports = __webpack_public_path__ + "media/images/icon__betPick--censored@3x-37e0a736f720d1f0709dd6c1ac47293d.png";